module.exports = "h1 {\n  color: green !important;\n  background-color: floralwhite; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/comodity/comodity.component.scss
// module id = ./src/app/comodity/comodity.component.scss
// module chunks = main